export enum ConjunctionMode {
  And = "AND",
  Or = "OR",
}
